import { Switch } from "antd";
import BetsSlip from "components/betsSlip";
import EventTableRow from "components/eventTableRow";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const EventTable = ({
    eventData,
    market,
    marketId,
    selection_id,
    setSelection_id,
    setHtmlId,
    type,
    handlePriceValue,
    BetPlaceData,
    placeStakeValue,
    StakeValue,
    setShowBetsSlip,
    showBetsSlip,
    handleOpenBetSlip,
    setSize,
    betPlace,
    is_fancy,
    checkHighestMarketPrice,
    loading,
    marketTypes,
    blockUnblockMarket,
    event_type_id,
    chips
}) => {
    const [status, setStatus] = useState(true);
    const { userdata } = useSelector((state) => state.authSlice);
    const handleSwitchChange = (market) => {
        blockUnblockMarket(market?.event_id, market?.market_id, market?.market_name, status && market?.market_name == "Match Odds" || market?.market_name == "Bookmaker" ? 'Suspended' : market?.market_name, event_type_id)
    };

    useEffect(() => {
        setStatus(marketTypes.find(bm => bm.market_id == market?.market_id)?.is_blocked !== "Yes");
    }, [marketTypes, market]);
    console.log('market:', market)
    return (
        market?.marketRunners?.length > 0 && (
            <div
                id={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && 'bookMakerMarket_30998640_130561'}`}
                className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && 'bets-bookmaker'}`}
            >
                <div className="live-match">
                    <div className="bg-[#fff] h-auto relative">
                        <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>
                            <span className="max-w-[220px] lg:max-w-[465px] mr-[.25rem] float-left  overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">{market?.market_name}</span>
                            <span className="max-w-[220px] lg:max-w-[465px] float-right overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap text-[#fff] text-[11px] capitalize">
                                <span className="hidden lg:block max-w-[220px] lg:max-w-[465px] float-left m-0 overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">Min: 1.00 | Max: 0.00</span>
                                <span className="max-w-[220px] lg:max-w-[465px] float-right overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap !pl-4">
                                    <i className="fa fa-minus" aria-hidden="true"></i>
                                </span>
                            </span>
                            {
                                !userdata?.user_type || userdata?.user_type == 'User' ? (
                                    <span class="max-w-[220px] lg:max-w-[465px] float-right overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap text-[#fff] text-[11px] capitalize">
                                        <button type="button" class="bg-[#959595] border-[1px] border-[solid] border-[#959595] text-[#fff] rounded-[2px] cursor-pointer text-[11px] font-bold px-[10px] py-[0] !mr-[.5rem]">Cashout</button>
                                    </span>
                                )
                                    :
                                    <span className="max-w-[220px] lg:max-w-[465px] float-right overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap text-[#fff] text-[11px] capitalize">
                                        {market.is_blocked !== "Yes" ?
                                            market.market_name == "Match Odds" || market.market_name == "Bookmaker" ?
                                                <Switch
                                                    className='tv-switch' size="small"
                                                    value={status}
                                                    onClick={() => {
                                                        blockUnblockMarket(market.event_id, market.market_id, 'Suspended', market.market_name)
                                                    }}

                                                />
                                                :
                                                <Switch
                                                    className='tv-switch' size="small"
                                                    value={status}
                                                    onChange={() => blockUnblockMarket(market.event_id, market.market_id, '', '')}

                                                />
                                            :
                                            <Switch
                                                className='tv-switch' size="small"
                                                value={status}
                                                onChange={() => blockUnblockMarket(market.event_id, market.market_id, market.market_name)}

                                            />
                                        }
                                        <button type="button" disabled="" className={`${status ? 'bg-[green]' : 'bg-[red]'}  text-[#fff] rounded-[2px] cursor-pointer text-[11px] font-bold px-[10px] py-[0] !mx-[.5rem]`}>{status ? 'Active' : 'Suspended'}</button>
                                    </span>
                            }
                        </p>
                    </div>
                </div>

                <div className="bg-[#fff]">
                    <table className={`relative mb-0 w-full text-[#212529] eventdetails bets ${eventData?.blockMarket?.length > 0 && eventData?.blockMarket?.find(bm => bm.market_id == market?.market_id)?.oddsType == "Suspended" ? "suspended-match" : ""} `}>
                        <tbody>
                            <tr className="bet-all-new leading-[22px]">
                                <td className="px-px py-[2px] relative text-left border-[#dee2e6] border-t-[1px] ">
                                    <span className="inline lg:hidden text-[#6a6a6a] text-[11px] capitalize">Min: 1.00 | Max: 1.00 </span>
                                </td>
                                <td className="px-px py-[2px] relative text-center  border-[#dee2e6] border-t-[1px]  pb-0 w-[45%] lg:w-[45%]">
                                    <div>
                                        <div className="w-[50%] float-left text-[#000] font-bold">
                                            <a id="btnBack" className="hidden lg:inline-block btn-back back-light-bg1 cursor-pointer  float-left text-[14px] px-[0] !py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] !bg-transparent mr-[1%]" side="Back">&nbsp;</a>
                                            <a id="btnBack" className="hidden lg:inline-block btn-back back-light-bg1 cursor-pointer  float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] !bg-transparent mr-[1%]" side="Back">&nbsp;</a>
                                            <a id="backAll" className="back-all cursor-pointer inline-block float-left text-[14px] px-[0] py-[4px] w-[98%] lg:w-[32.33%] bg-[url(https://images.staticcontent.io/rde/uimg/main-s1.png)] bg-no-repeat bg-[-274px_-273px] rounded-[4px] !leading-[13px] [color:inherit] mr-[1%]">
                                                <img className="bg-[0_-5357px] bg-repeat-x max-w-full" alt="" src="https://images.staticcontent.io/rde/uimg/transparent.gif" />
                                                <span className="text-[14px] text-[#000] font-bold">Back</span>
                                            </a>
                                        </div>
                                        <div className="w-[50%] float-left text-[#000] font-bold">
                                            <a id="layall" className="lay-all cursor-pointer inline-block float-left text-[14px] px-[0] py-[4px] w-[98%] lg:w-[32.33%] bg-[url(https://images.staticcontent.io/rde/uimg/main-s1.png)] bg-no-repeat bg-[100%_-399px] rounded-[4px] !leading-[13px] [color:inherit] mr-[1%]">
                                                <img className=" max-w-full" alt="" src="https://images.staticcontent.io/rde/uimg/transparent.gif" />
                                                <span className="text-[14px] text-[#000] font-bold">Lay</span>
                                            </a>
                                            <a id="btnBack" className="hidden lg:inline-block btn-back back-light-bg1 cursor-pointer  float-left text-[14px] px-[0] !py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] !bg-transparent mr-[1%]" side="Back">&nbsp;</a>
                                            <a id="btnBack" className="hidden lg:inline-block btn-back back-light-bg1 cursor-pointer  float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] !bg-transparent mr-[1%]" side="Back">&nbsp;</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            {
                                market?.marketRunners?.length > 0 && market?.marketRunners?.map((runner, index) => (
                                    <>
                                        <div className={` ${runner.status == "SUSPENDED" ? '' : 'hidden'} bg-[url(https://images.staticcontent.io/rde/uimg/bg-disabled.png)] bg-[rgba(0,_0,_0,_.5)] text-[red] absolute w-[40%] lg:w-[48%] z-[5] right-0 text-center suspended_${runner.market_id.replace('.', '')}_${runner.selection_id}`}>
                                            <span className='leading-[46px] text-[12px] font-semibold opacity-[.8] text-[red] [text-shadow:0_1px_4px_rgba(0,_0,_0,_.5)] text-center normal-case p-[.5rem] bg-transparent [box-shadow:inset_0_0_0_9999px_transparent]'> Suspended </span>
                                        </div>
                                        <EventTableRow key={index} index={index} eventData={eventData} market={market} runner={runner} type={type} showBetsSlip={showBetsSlip} setShowBetsSlip={setShowBetsSlip} handleOpenBetSlip={handleOpenBetSlip} is_fancy={is_fancy} checkHighestMarketPrice={checkHighestMarketPrice} />
                                        {showBetsSlip && marketId === runner?.market_id && runner?.selection_id == selection_id && (
                                            <BetsSlip
                                                eventData={eventData}
                                                market={market}
                                                runner={runner}
                                                type={type}
                                                setSelection_id={setSelection_id}
                                                setHtmlId={setHtmlId}
                                                handlePriceValue={handlePriceValue}
                                                BetPlaceData={BetPlaceData}
                                                placeStakeValue={placeStakeValue}
                                                StakeValue={StakeValue}
                                                showBetsSlip={showBetsSlip}
                                                setShowBetsSlip={setShowBetsSlip}
                                                setSize={setSize}
                                                betPlace={betPlace}
                                                loading={loading}
                                                chips={chips}
                                            />
                                        )}
                                    </>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    );
}

export default EventTable;